import _ from 'lodash';
var userAgent = typeof window !== 'undefined' && !_.isUndefined(window.navigator)
    ? window.navigator.userAgent
    : null;
export var isNotValidUserAgent = function () {
    return /BonEcho|NewsGator|SeaMonkey|iTunes|Epiphany|Konqueror|Sleipnir|IceWeasel/i.test(userAgent);
};
export var isBot = function () {
    return /Googlebot|AdsBot-Google-Mobile|bingbot|BingPreview|facebookexternalhit|Baiduspider|YandexBot/i.test(userAgent);
};
//# sourceMappingURL=validateUserAgent.js.map